import React, { Component } from "react";
import { bindActionCreators } from "redux";

import connect from "react-redux/es/connect/connect";
import { trimFormData, capitalizeFirstLetter } from "../../../../utils/common";
import * as validator from "../../../../utils/validator";
import {
  USER_DETAILS,
  ADD_NOTIFICATION,
  EDIT_NOTIFICATION,
  NOTIFICATION_MANAGEMENT,
  NOTIFICATION_ACTIVITY_LOG,
} from "../../../../navigation/routes";

// import "./UserManagementStyles.scss";

import {
  editNotification,
  getNotificationById,
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
} from "../../../../store/notificationManagement/notificationManagementActions";
import { getPlatformsList } from "../../../../store/master/masterActions";
import { history } from "../../../../store/configure/configureStore";

import UpdateNotificationView from "./UpdateNotificationView";

class UpdateNotificationContainer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      fields: {
        title: "",
        description: "",
        notificationAction: "",
        platform: { label: "", value: "" },
        fileURL: "",
        file: "",
        actionButtons: [
          {
            actionNameIndex: "Action 1",
            title: "",
            content: "",
          },
        ],
      },
      initialFields: {},
      errors: {},
    };

    this.handleInputChange = this.handleInputChange.bind(this);
    this.handleFileChange = this.handleFileChange.bind(this);
    //
    this.handlePreFillValuesInState =
      this.handlePreFillValuesInState.bind(this);
  }

  componentDidUpdate(prevProps, prevState) {
    if (prevProps.notificationDataById !== this.props.notificationDataById) {
      this.handlePreFillValuesInState();
    }
  }

  handlePreFillValuesInState = (previousData) => {
    const {
      title = "",
      body = "",
      link = "",
      actionButton = [],
      presignedUrl = "",
      platformId = { label: "", value: "" },
    } = this.props?.notificationDataById || {};

    // Prepare the pre-filled action buttons
    const actionButtons = actionButton.map((button, index) => ({
      actionNameIndex: `Action ${index + 1}`,
      title: button.title || "",
      content: button.content || "",
    }));

    this.setState(
      (prevState) => ({
        fields: {
          ...prevState.fields,
          title: title,
          description: body,
          notificationAction: link,
          platform: platformId
            ? { label: platformId?.label, value: platformId?._id }
            : null,
          fileURL: presignedUrl,
          actionButtons: actionButtons,
        },
        initialFields: {
          ...prevState.fields,
          title: title,
          description: body,
          notificationAction: link,
          platform: platformId
            ? { label: platformId?.label, value: platformId?._id }
            : null,
          fileURL: presignedUrl,
          actionButtons: actionButtons,
        },
        errors: {}, // Reset errors or handle errors here if needed
      }),
      () => {
        // Callback after state is updated
        console.log("prefilled state", this.state);
      }
    );
  };

  componentDidMount() {
    const id = this.props.match.params.id;

    this.props.getNotificationById(id);
    this.props.getPlatformsList();
  }

  componentWillUnmount() {
    this.resetTheReduxStateOnUnmount();
  }

  resetTheReduxStateOnUnmount = () => {
    const location = window?.location?.pathname;
    if (
      !location?.includes(EDIT_NOTIFICATION) &&
      !location?.includes(NOTIFICATION_ACTIVITY_LOG) &&
      !location?.includes(NOTIFICATION_MANAGEMENT)
    ) {
      //--------------------------reset redux rowsPerPage state when unmounting
      const resetRowsPerPageData = { label: "10", value: 10 };
      this.props?.updateRowsPerPage(resetRowsPerPageData);
      this.props?.updateCurrentPage(1);
      //--------------------------reset redux fields state when unmounting
      const resetFields = { searchString: "" };
      this.props.updateSearchFilters(resetFields);
    }
  };

  //--------------------------field handlers

  handleInputChange = ({ target }, capitalize) => {
    const field = target.name;
    const value = capitalize
      ? capitalizeFirstLetter(target.value)
      : target.value;

    this.setState(
      (prevState) => {
        const updatedErrors = { ...prevState.errors };
        delete updatedErrors[field]; // Remove the error for the updated field

        return {
          fields: {
            ...prevState.fields,
            [field]: value,
          },
          errors: updatedErrors,
        };
      },
      () => console.log(this.state.fields)
    );
  };

  // handleActionButtonInputChange = (
  //   { target },
  //   capitalize,
  //   inputFor,
  //   indexOfActionButton
  // ) => {
  //   const field = target.name;
  //   const buttons = this.state?.fields?.actionButtons;

  //   const updatedStateOfButton = buttons.map((item, index) => {
  //     if (indexOfActionButton === index) {
  //       // Return a new object with the updated content
  //       return {
  //         ...item,
  //         title:
  //           inputFor === "label"
  //             ? capitalizeFirstLetter(target.value)
  //             : item.title,
  //         content: inputFor === "content" ? target.value : item.content,
  //       };
  //     }
  //     // Return the original button if no match
  //     return item;
  //   });

  //   this.setState(
  //     (prev) => ({
  //       fields: {
  //         ...prev.fields,
  //         actionButtons: updatedStateOfButton,
  //       },
  //       errors: {},
  //     }),
  //     () => console.log(this.state?.fields?.actionButtons)
  //   );
  // };

  handleActionButtonInputChange = (
    { target },
    capitalize,
    inputFor,
    indexOfActionButton
  ) => {
    const field = target.name;
    const buttons = this.state?.fields?.actionButtons;

    const updatedStateOfButton = buttons.map((item, index) => {
      if (indexOfActionButton === index) {
        // Return a new object with the updated content
        return {
          ...item,
          title:
            inputFor === "label"
              ? capitalizeFirstLetter(target.value)
              : item.title,
          content: inputFor === "content" ? target.value : item.content,
        };
      }
      // Return the original button if no match
      return item;
    });

    this.setState(
      (prevState) => {
        const updatedErrors = { ...prevState.errors };

        // Remove error for the specific action button, e.g., "Action 1", "Action 2"
        delete updatedErrors[`Action ${indexOfActionButton + 1}`];
        // Remove error for the specific action button url, e.g., "Action 1_content", "Action 2_content"
        if (inputFor === "content") {
          delete updatedErrors[`Action ${indexOfActionButton + 1}_content`];
        }

        return {
          fields: {
            ...prevState.fields,
            actionButtons: updatedStateOfButton,
          },
          errors: updatedErrors,
        };
      },
      () => console.log(this.state?.errors)
    );
  };

  handleDropdownSelectionForPlatform = (value) => {
    // console.log("value", value);
    this.setState(
      {
        fields: { ...this.state.fields, platform: value },
        errors: {},
      },
      () => console.log(this.state?.fields)
    );
  };

  //--------------------------handle action buttons
  // onClickAddActionButton = () => {
  //   const createObject = (index) => {
  //     return {
  //       actionNameIndex: `Action ${index}`,
  //       label: "",
  //       content: "",
  //     };
  //   };

  //   this.setState(
  //     (prevState) => {
  //       const currentLength = prevState.fields.actionButtons.length;
  //       const newActionButton = createObject(currentLength + 1); // Append Action 1, 2, 3, etc.

  //       return {
  //         fields: {
  //           ...prevState.fields,
  //           actionButtons: [...prevState.fields.actionButtons, newActionButton],
  //         },
  //       };
  //     },
  //     () => console.log("actionbtn", this.state?.fields?.actionButtons)
  //   );
  // };

  onClickAddActionButton = () => {
    const createObject = (index) => {
      return {
        actionNameIndex: `Action ${index}`,
        title: "",
        content: "",
      };
    };

    // const actionButtonFieldName = this.state?.fields?.actionButtons?.map(
    //   (item) => item?.actionNameIndex
    // );

    // // console.log("actionButtonFieldName", actionButtonFieldName);

    // const validatorFields = {
    //   required: actionButtonFieldName, //array of names
    // };

    // const actionButtonData = this.state?.fields?.actionButtons || [];

    // // Validate current fields
    // const fields = {};
    // actionButtonData.forEach((button, index) => {
    //   fields[button.actionNameIndex] = button.title || ""; // Use actionNameIndex as the key
    // });

    const actionButtonData = this.state?.fields?.actionButtons || [];

    const validatorFields = {
      required: actionButtonData?.map((item) => item?.actionNameIndex), //array of names
      custom: [],
    };

    // Validate current fields
    const fields = {};
    actionButtonData.forEach((button, index) => {
      fields[button.actionNameIndex] = button.title || ""; // Use actionNameIndex as the key
    });

    // Add custom validation only if content is not empty
    actionButtonData.forEach((item) => {
      // Check if content is not empty
      if (item.content) {
        fields[`${item.actionNameIndex}_content`] = item.content || "";
        validatorFields.custom.push(
          validator.link([`${item.actionNameIndex}_content`])
        );
      }
    });

    const { errors } = validator.validate(
      validatorFields,
      fields
      // trimFormData(fields)
    );

    this.setState((prev) => ({
      ...prev,
      errors: { ...prev?.errors, ...errors },
    }));

    console.log("errors", errors);

    if (!Object.keys(errors).length) {
      this.setState(
        (prevState) => {
          const currentLength = prevState.fields.actionButtons.length;
          const newActionButton = createObject(currentLength + 1); // Append Action 1, 2, 3, etc.

          return {
            fields: {
              ...prevState.fields,
              actionButtons: [
                ...prevState.fields.actionButtons,
                newActionButton,
              ],
            },
          };
        }
        // () => console.log("actionbtn", this.state?.fields?.actionButtons)
      );
    }
  };

  onClickRemoveActionButton = (actionNameIndex) => {
    this.setState(
      (prevState) => {
        // Remove errors related to the removed action button
        const updatedErrors = { ...prevState.errors };
        delete updatedErrors[actionNameIndex]; // Remove error for the specific actionNameIndex
        delete updatedErrors[`${actionNameIndex}_content`]; // Remove error for the specific actionNameIndex

        // Filter out the action button to be removed
        const updatedActionButtons = prevState.fields.actionButtons
          .filter((button) => button.actionNameIndex !== actionNameIndex)
          // After removing, regenerate the actionNameIndex based on the new array length
          .map((button, index) => ({
            ...button,
            actionNameIndex: `Action ${index + 1}`, // Update the index to be sequential
          }));

        return {
          fields: {
            ...prevState.fields,
            actionButtons: updatedActionButtons,
          },
          errors: updatedErrors, // Update errors in state
        };
      }
      // () =>
      //   console.log(
      //     "Updated action buttons:",
      //     this.state?.fields?.actionButtons
      //   )
    );
  };

  handleFileChange(event) {
    const file = event.target.files[0];

    if (file) {
      const reader = new FileReader();

      reader.onloadend = () => {
        this.setState((prev) => ({
          ...prev,
          fields: { ...prev.fields, fileURL: reader.result },
        }));
      };

      reader.readAsDataURL(file);

      this.setState(
        (prev) => ({
          ...prev,
          fields: { ...prev.fields, file: file },
        }),
        () => {
          // Reset file input value to allow re-uploading the same file
          event.target.value = null;
        }
      );
    }
  }

  handleOnClickRemoveImage = () => {
    this.setState((prev) => ({
      ...prev,
      fields: {
        ...prev.fields,
        fileURL: "",
        file: "",
      },
    }));
  };

  hasFieldsChanged = () => {
    const { fields, initialFields } = this.state;

    return JSON.stringify(fields) !== JSON.stringify(initialFields);
  };

  onClickSave = () => {
    const fieldsData = this.state?.fields;

    const validatorFields = {
      required: ["title", "description"],
      custom: [],
      // custom: [validator.link(["notificationAction"])],
    };

    // Check if notificationAction is not empty and add custom validation
    if (fieldsData?.notificationAction) {
      validatorFields.custom = [validator.link(["notificationAction"])];
    }

    // validation fields
    const fields = {
      title: fieldsData?.title,
      description: fieldsData?.description,
      notificationAction: fieldsData?.notificationAction,
    };

    const actionButtonData = this.state?.fields?.actionButtons || [];
    // Add custom validation only if content is not empty
    actionButtonData.forEach((item) => {
      // Check if content is not empty
      if (item.content) {
        fields[`${item.actionNameIndex}_content`] = item.content || "";
        validatorFields.custom.push(
          validator.link([`${item.actionNameIndex}_content`])
        );
      }
    });

    const { errors } = validator.validate(
      validatorFields,
      fields
      // trimFormData(fields)
    );

    console.log("state", this.state);
    console.log("errors", errors);

    const actionButtons = fieldsData?.actionButtons;
    // Filter out actionButtons without a label and remove actionNameIndex
    const modifiedActionButtons = actionButtons
      .filter(({ title }) => title) // Keep only objects with a non-empty title
      .map(({ actionNameIndex, ...rest }) => rest); // Remove actionNameIndex

    // this.setState({ ...this.state, errors });
    this.setState((prev) => ({
      ...prev,
      errors: { ...prev?.errors, ...errors },
    }));

    const formData = new FormData();
    // formData.append("file", fieldsData.file || null);
    if (fieldsData.fileURL !== "") {
      formData.append("file", fieldsData.file || null);
    }
    formData.append("title", fieldsData?.title);
    formData.append("body", fieldsData?.description);
    formData.append("link", fieldsData?.notificationAction);
    formData.append("actionButton", JSON.stringify(modifiedActionButtons));
    formData.append("platformId", fieldsData?.platform?.value || "");
    if (fieldsData.fileURL === "") {
      formData.append("imageRemoved", true);
    }

    // Log the formData entries
    // for (let [key, value] of formData.entries()) {
    //   console.log(`${key}: ${value}`);
    // }

    if (!Object.keys(errors).length) {
      this.props.editNotification(
        this.props.notificationDataById._id,
        formData,
        // () => history.push(NOTIFICATION_MANAGEMENT)
        () => {
          const id = this.props.match.params.id;

          this.props.getNotificationById(id);
        }
      );
    }
  };

  onClickCancel = () => {
    history?.goBack();
  };

  render() {
    //--------------------------dropdown options

    const platformsDropDownOptions = this.props?.platforms?.map((item) => ({
      label: item?.label,
      value: item?._id,
    }));

    return (
      <UpdateNotificationView
        //all the states
        id={this.props.match.params.id}
        fields={this.state?.fields}
        initialFields={this.state?.initialFields}
        errors={this.state?.errors}
        //input handler
        handleInputChange={this.handleInputChange}
        handleActionButtonInputChange={this.handleActionButtonInputChange}
        handleDropdownSelectionForPlatform={
          this.handleDropdownSelectionForPlatform
        }
        handleFileChange={this.handleFileChange}
        handleOnClickRemoveImage={this.handleOnClickRemoveImage}
        //click handler
        onClickAddActionButton={this.onClickAddActionButton}
        onClickRemoveActionButton={this.onClickRemoveActionButton}
        //API's
        onClickSave={this.onClickSave}
        //dropdown options
        platformsDropDownOptions={platformsDropDownOptions}
        //permissions
        userPermissions={this.props.userPermissions}
        //other
        hasFieldsChanged={this.hasFieldsChanged}
        //
        onClickCancel={this.onClickCancel}
      />
    );
  }
}

UpdateNotificationContainer.propTypes = {};

const mapStateToProps = (state) => ({
  fields: state.notificationManagement.fields,
  notificationDataById: state.notificationManagement.notificationDataById,
  //
  platforms: state.master.platforms,
  //
  userPermissions: state.auth.userPermissions,
});

export default connect(mapStateToProps, {
  editNotification,
  getNotificationById,
  getPlatformsList,
  //
  updateRowsPerPage,
  updateSearchFilters,
  updateCurrentPage,
})(UpdateNotificationContainer);
